(function () {
  'use strict';
  if (window.IAFeaturedDinnerTrackingLoaded) return;
  window.IAFeaturedDinnerTrackingLoaded = true;

  var PRODUCT_HANDLE = 'pita-pizza-night-kit';
  var PRODUCT_NAME = 'Pita Pizza Night Kit (8 Mini Pizzas)';
  var VARIANT_ID = '54166427009208';
  var PRICE = 29;
  var CURRENCY = 'USD';

  function sourceFromUrl() {
    try { return new URL(window.location.href).searchParams.get('ia_source') || ''; }
    catch (e) { return ''; }
  }

  function payload(source, extra) {
    return Object.assign({
      item_id: VARIANT_ID,
      item_name: PRODUCT_NAME,
      item_handle: PRODUCT_HANDLE,
      price: PRICE,
      currency: CURRENCY,
      ia_source: source || sourceFromUrl() || 'direct',
      page_location: window.location.href,
      page_path: window.location.pathname
    }, extra || {});
  }

  function track(name, parameters) {
    var data = parameters || {};
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, data));
    if (typeof window.gtag === 'function') window.gtag('event', name, data);
    try {
      document.dispatchEvent(new CustomEvent('ia:featured-dinner', { detail: { event: name, parameters: data } }));
    } catch (e) {}
  }

  function featuredDinnerQuantity(cart) {
    return (cart.items || []).reduce(function (total, item) {
      return total + (String(item.variant_id) === VARIANT_ID ? Number(item.quantity || 0) : 0);
    }, 0);
  }

  function getCartQuantity() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(featuredDinnerQuantity)
      .catch(function () { return null; });
  }

  function rememberPendingAdd(source) {
    try {
      sessionStorage.setItem('iaFeaturedDinnerPendingAdd', JSON.stringify({ source: source, createdAt: Date.now() }));
    } catch (e) {}
  }

  function clearPendingAdd() {
    try { sessionStorage.removeItem('iaFeaturedDinnerPendingAdd'); }
    catch (e) {}
  }

  function resolvePendingAdd() {
    var pending = null;
    try { pending = JSON.parse(sessionStorage.getItem('iaFeaturedDinnerPendingAdd') || 'null'); }
    catch (e) {}
    if (!pending || Date.now() - Number(pending.createdAt || 0) > 120000) {
      clearPendingAdd();
      return;
    }
    getCartQuantity().then(function (quantity) {
      if (quantity && quantity > 0) {
        track('featured_dinner_add_to_cart_success', payload(pending.source, {
          quantity: 1,
          value: PRICE,
          form_location: 'product_page_redirect'
        }));
      }
      clearPendingAdd();
    });
  }

  function initCards() {
    var cards = document.querySelectorAll('[data-ia-featured-dinner]');
    if (!cards.length) return;

    var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.35) return;
        var card = entry.target;
        if (card.dataset.iaImpressionTracked === 'true') return;
        card.dataset.iaImpressionTracked = 'true';
        track('featured_dinner_impression', payload(card.dataset.iaSource, { visibility_threshold: 0.35 }));
        observer.unobserve(card);
      });
    }, { threshold: [0.35] }) : null;

    cards.forEach(function (card) {
      if (observer) observer.observe(card);
      else track('featured_dinner_impression', payload(card.dataset.iaSource));
    });

    document.querySelectorAll('[data-ia-featured-dinner-link]').forEach(function (link) {
      link.addEventListener('click', function () {
        var card = link.closest('[data-ia-featured-dinner]');
        track('featured_dinner_product_click', payload(card ? card.dataset.iaSource : 'unknown', { link_url: link.href }));
      });
    });

    document.querySelectorAll('[data-ia-featured-dinner-form]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var card = form.closest('[data-ia-featured-dinner]');
        var source = card ? card.dataset.iaSource : 'unknown';
        var button = form.querySelector('[data-ia-featured-dinner-add]');
        var status = form.querySelector('[data-ia-featured-dinner-status]');
        var original = button ? button.textContent : '';

        track('featured_dinner_add_to_cart_attempt', payload(source, { quantity: 1 }));
        if (button) { button.disabled = true; button.textContent = 'Adding Pizza Night…'; }
        if (status) { status.textContent = ''; status.classList.remove('is-error'); }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            id: Number(VARIANT_ID),
            quantity: 1,
            properties: {
              '_ia_featured_dinner': 'pita_pizza_night',
              '_ia_featured_dinner_source': source
            }
          })
        }).then(function (response) {
          if (!response.ok) return response.json().then(function (body) { throw new Error(body.description || 'Unable to add the kit.'); });
          return response.json();
        }).then(function () {
          track('featured_dinner_add_to_cart_success', payload(source, { quantity: 1, value: PRICE }));
          if (status) status.textContent = 'Added. Opening your cart…';
          if (button) button.textContent = 'Added to cart';
          window.setTimeout(function () { window.location.assign('/cart'); }, 450);
        }).catch(function (error) {
          track('featured_dinner_add_to_cart_error', payload(source, { error_message: error.message || 'Unknown error' }));
          if (status) { status.textContent = error.message || 'Unable to add the kit. Please try again.'; status.classList.add('is-error'); }
          if (button) { button.disabled = false; button.textContent = original; }
        });
      });
    });
  }

  function initProductPage() {
    if (window.location.pathname !== '/products/' + PRODUCT_HANDLE) return;
    var source = sourceFromUrl() || 'product_page';
    track('featured_dinner_product_view', payload(source));
    document.querySelectorAll('input[data-ia-featured-dinner-source]').forEach(function (input) { input.value = source; });
    var form = document.getElementById('ia-atc-form');
    var button = document.getElementById('ia-atc-btn-fallback');
    var lastAttemptAt = 0;
    var lastKnownQuantity = 0;
    getCartQuantity().then(function (quantity) {
      if (quantity !== null) lastKnownQuantity = quantity;
    });
    function confirmAddSuccess(beforeQuantity, remainingChecks) {
      window.setTimeout(function () {
        getCartQuantity().then(function (afterQuantity) {
          if (afterQuantity === null) return;
          if (afterQuantity > beforeQuantity) {
            track('featured_dinner_add_to_cart_success', payload(source, {
              quantity: afterQuantity - beforeQuantity,
              value: PRICE * (afterQuantity - beforeQuantity),
              form_location: 'product_page'
            }));
            clearPendingAdd();
            lastKnownQuantity = afterQuantity;
            return;
          }
          if (remainingChecks > 1) {
            confirmAddSuccess(beforeQuantity, remainingChecks - 1);
          } else {
            lastKnownQuantity = afterQuantity;
          }
        });
      }, 700);
    }
    function recordAddIntent() {
      var now = Date.now();
      if (now - lastAttemptAt < 500) return;
      lastAttemptAt = now;
      var beforeQuantity = Promise.resolve(lastKnownQuantity);
      rememberPendingAdd(source);
      track('featured_dinner_add_to_cart_attempt', payload(source, { quantity: 1, form_location: 'product_page' }));
      beforeQuantity.then(function (quantity) { confirmAddSuccess(quantity, 7); });
    }
    if (form) form.addEventListener('submit', recordAddIntent);
    if (button) button.addEventListener('click', recordAddIntent, true);
  }

  function initRemovalTracking() {
    var removalCheckPending = false;
    document.addEventListener('click', function (event) {
      var control = event.target.closest('cart-remove-button a, a[href*="/cart/change"], button[data-cart-remove], button[name="updates[]"], .quantity__button');
      if (!control || removalCheckPending) return;
      removalCheckPending = true;
      var beforeQuantity = getCartQuantity();
      window.setTimeout(function () {
        Promise.all([beforeQuantity, getCartQuantity()]).then(function (quantities) {
          if (quantities[0] !== null && quantities[1] !== null && quantities[1] < quantities[0]) {
            track('featured_dinner_cart_remove', payload('cart', {
              quantity_removed: quantities[0] - quantities[1],
              remaining_quantity: quantities[1]
            }));
          }
          removalCheckPending = false;
        });
      }, 1000);
    }, true);
  }

  function init() {
    resolvePendingAdd();
    initCards();
    initProductPage();
    initRemovalTracking();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
